const LogoSvgLight = () => {
  return (
    <img className="w-full hidden dark:block" width={96}
    height={47} src="/yataybeyaz.svg"/>
  );
};

export default LogoSvgLight;
